import { Play, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { VIDEOS } from "../../data/content";
import { YOUTUBE_CHANNEL } from "../../lib/api";

export default function Watch() {
  return (
    <section id="watch" className="relative py-24 md:py-36 bg-obsidian overflow-hidden" data-testid="watch-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal>
          <Eyebrow index="03" label="YOUTUBE NETWORK" />
          <div className="flex flex-wrap items-end justify-between gap-6">
            <h2 className="font-display text-cream text-6xl md:text-8xl tracking-tight leading-[0.85]" data-testid="watch-heading">
              SEE THE <span className="text-burnt">CULTURE.</span>
            </h2>
            <a
              href={YOUTUBE_CHANNEL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="watch-youtube-cta"
              className="group flex items-center gap-2 border border-tan/40 hover:border-burnt hover:bg-burnt/10 text-cream font-mono text-[11px] tracking-[0.2em] px-6 py-3.5 rounded-full transition-all duration-300"
            >
              WATCH ON YOUTUBE
              <ArrowUpRight size={14} className="text-burnt transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.15}>
        <div className="mt-14 flex gap-5 overflow-x-auto no-scrollbar snap-x snap-mandatory px-5 md:px-10 pb-4" data-testid="watch-video-rail">
          {VIDEOS.map((v, i) => (
            <a
              key={v.id}
              href={YOUTUBE_CHANNEL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`watch-video-card-${i}`}
              className="group relative shrink-0 w-[82vw] sm:w-[420px] snap-start"
            >
              <div className="relative overflow-hidden border border-woodborder bg-card">
                <img
                  src={v.thumb}
                  alt={v.title}
                  loading="lazy"
                  className="w-full aspect-video object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700 ease-out"
                />
                <span className="absolute top-4 left-4 font-mono text-[10px] tracking-[0.2em] bg-obsidian/80 backdrop-blur px-3 py-1.5 text-tan border border-tan/20">
                  {v.tag}
                </span>
                <span className="absolute bottom-4 right-4 font-mono text-[10px] tracking-[0.15em] bg-obsidian/80 backdrop-blur px-2.5 py-1.5 text-cream">
                  {v.duration}
                </span>
                <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <span className="w-16 h-16 rounded-full bg-burnt flex items-center justify-center shadow-[0_0_44px_rgba(200,90,23,0.6)] scale-75 group-hover:scale-100 transition-transform duration-500">
                    <Play size={22} className="fill-cream text-cream ml-1" />
                  </span>
                </span>
              </div>
              <div className="mt-4 flex items-start justify-between gap-4">
                <h3 className="font-editorial font-bold text-cream text-lg leading-snug group-hover:text-tan-light transition-colors duration-300">
                  {v.title}
                </h3>
                <span className="font-mono text-[10px] text-clay pt-1.5 shrink-0">EP/{String(i + 1).padStart(2, "0")}</span>
              </div>
            </a>
          ))}
          <a
            href={YOUTUBE_CHANNEL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="watch-view-all-card"
            className="group shrink-0 w-[60vw] sm:w-[280px] snap-start border border-dashed border-tan/30 hover:border-burnt flex flex-col items-center justify-center gap-4 transition-colors duration-300 min-h-[240px]"
          >
            <span className="font-display text-4xl text-tan group-hover:text-burnt transition-colors">FULL ARCHIVE</span>
            <span className="flex items-center gap-2 font-mono text-[10px] tracking-[0.2em] text-clay group-hover:text-tan transition-colors">
              @THECOBAINREPORT <ArrowUpRight size={13} />
            </span>
          </a>
        </div>
      </Reveal>
    </section>
  );
}
